module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/53d714f86f767db7484bedc97c0da7ed.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_3.svg
// module id = sO5X
// module chunks = 0